export enum TimelineMode {
  Default = 'default',
  Create = 'create',
}
